import React from 'react';

const Play = () => (
  <svg height="6" width="5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M.715.562v4.876c0 .103.098.167.176.115l3.623-2.438c.077-.05.077-.178 0-.23L.891.449C.813.395.715.459.715.562z" />
  </svg>
);

export default Play;
